// const store = require('../store/store')
import { Message } from 'view-design';
import axios from 'axios';
export default {
    install(Vue) {
        // 验证数据是否为空
        Vue.prototype.$isEmpty = function(value) {
            // 判断字符串是否为空
            switch (typeof(value)) {
                case "undefined":
                    return true
                case "boolean":
                    return false
                case "string":
                    return value === ""
                case "number":
                    return isNaN(value)
                case "object":
                    // 数组
                    if (Array.isArray(value)) {
                        return value.length === 0
                    } else {
                        // null
                        if (value === null) {
                            return true
                        }
                        // 其他对象统一不认为为空
                        if (Object.prototype.toString.call(value) !== "[object Object]") {
                            return false
                        }
                        // 普通对象如果可枚举属性为空认为该对象为空
                        return Object.keys(value).length === 0
                    }
                default:
                    console.error("未知")
                    return true
            }
        };
        // 转换字符
        Vue.prototype.$replaceAllStr = function(value, regexp, substr) {
            if (this.$isEmpty(value)) {
                return '';
            }
            return value.replace(new RegExp(regexp, 'gm'), substr);
        };
        // 根据value从List中获取对应label值
        Vue.prototype.$getListValue = function(value, list) {
            // 对象数组的类型不是数组
            if (!Array.isArray(list)) {
                console.error("对应的对象数组格式错误");
                return "";
            }
            let result = list.find(el => value === el.value);
            // 如果找不到对应对象获取对象的label属性为空
            if (!result || !result.label) {
                return "";
            }
            return result.label;
        };
        Vue.prototype.$regSpecial = str => {
            //
            if (typeof str !== 'string') {
                return { value: false, msg: '请传入一个字符串类型数据' };
            }
            if (str === "") {
                return { value: false, msg: '请传入非空数据' };
            }
            let regEn = /[`~!@#$%^&*()_+<>?:"{},./;'[\]]/im,
                regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
            if (regEn.test(str) || regCn.test(str)) {
                return { value: false, msg: '包含特殊字符' };
            } else {
                return { value: true, msg: '验证成功' };
            }
        };
        // 按钮权限测试
        // Vue.prototype.$btnAuthorityTest = key => {
        //     let btnList = store.default.getters["skb/getBtnAuthorityList"]
        //     return btnList.includes(key)
        // };
        // 数组去重
        Vue.prototype.$removal = arr => {
            if (!Array.isArray(arr)) {
                return arr
            }
            return Array.from(new Set(arr))
        };
        // 时间段查询时截至时间增加到当天23：59：59
        Vue.prototype.$endTime = endTime => {
            if (endTime) {
                endTime = Vue.prototype.$tagTime(endTime, "yyyy-MM-dd") + " " + "23:59:59";
                return new Date(endTime);
            } else {
                return endTime
            }
        };
        /**
         * 交换给定数组的给定两位置的元素后返回置换后的新数组
         */
        Vue.prototype.$displace = (index1, index2, array) => {
            let newArray = [...array],
                tmpVal = newArray[index1],
                max, min,
                oneArray, twoArray, threeArray
            if (index1 > index2) {
                min = index2
                max = index1
                oneArray = newArray.slice(0, min)
                twoArray = newArray.slice(min, max)
                threeArray = newArray.slice(max + 1, newArray.length)
                return [...oneArray, tmpVal, ...twoArray, ...threeArray]
            } else {
                min = index1
                max = index2
                oneArray = newArray.slice(0, min)
                twoArray = newArray.slice(min + 1, max + 1)
                threeArray = newArray.slice(max + 1, newArray.length + 1)
                return [...oneArray, ...twoArray, tmpVal, ...threeArray]
            }
        }
        Vue.prototype.$throttle = (callback, time) => {
            let timer = null;
            return function() {
                if (timer) return;
                timer = setTimeout(() => {
                    callback.apply(this, arguments);
                    timer = null;
                }, time);
            };
        };
        /**
         * time 时间对象
         * tag 传入想要得到的时间格式 yyyy-MM-dd HH-mm-ss
         */
        Vue.prototype.$tagTime = (time, tag) => {
            if (!tag) {
                return ""
            }
            if (!time) {
                return ""
            }
            let tmpTime = new Date(time)
            if (isNaN(tmpTime)) {
                return ""
            }
            let year = tmpTime.getFullYear(),
                month = tmpTime.getMonth() + 1,
                date = tmpTime.getDate(),
                hour = tmpTime.getHours(),
                minute = tmpTime.getMinutes(),
                second = tmpTime.getSeconds()
                // 不足10前面补0
            if (month < 10) {
                month = "0" + month
            }
            // 不足10前面补0
            if (date < 10) {
                date = "0" + date
            }
            // 不足10前面补0
            if (hour < 10) {
                hour = "0" + hour
            }
            // 不足10前面补0
            if (minute < 10) {
                minute = "0" + minute
            }
            // 不足10前面补0
            if (second < 10) {
                second = "0" + second
            }
            return tag.replace("yyyy", year).replace("MM", month).replace("dd", date).replace("HH", hour).replace("mm", minute).replace("ss", second)
        };
        // 00:00:00  => ms
        Vue.prototype.$toMs = (time) => {
            let s = '';
            let hour = time.split(':')[0];
            let min = time.split(':')[1];
            let sec = time.split(':')[2];
            s = Number(hour * 3600) + Number(min * 60) + Number(sec);

            return s * 1000;
        };
        Vue.prototype.$handleDown = (params, url) => {
            axios({
                method: 'post',
                url: url,
                data: params,
                responseType: 'blob'
            }).then(res => {
                let r = new FileReader()
                r.onload = function() {
                    try {
                        //不是对象，返回文件流json会报语法错误
                        let jsonData = JSON.parse(this.result);
                        if (jsonData.code != 10000) {
                            Message.error(jsonData.msg)
                        }
                    } catch (err) {
                        // 解析成对象失败，说明是正常的文件流
                        let fileName = res.headers['content-disposition'] ? '' + res.headers['content-disposition'].split('=')[1].toString() : ''
                        if (!res) {
                            return
                        }
                        // let types = type ? "application/type" : "application/vnd.ms-excel"
                        // let url = window.URL.createObjectURL(new Blob([res.data], { type: types }))
                        let url = window.URL.createObjectURL(new Blob([res.data]))
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        link.setAttribute('download', decodeURIComponent(fileName))
                        document.body.appendChild(link)
                        link.click()
                    }
                }
                r.readAsText(res.data)
            }).catch(err => {
                console.log(err, 'err')
            })
        };

        Vue.prototype.$debounce = (callback, wait) => {
            let lastTime = new Date()
                // console.log(callback, wait)
            return () => {
                let currentTime = new Date()
                let remaining = currentTime - lastTime - wait
                if (remaining >= 0) {
                    callback()
                    lastTime = currentTime
                }
            }
        };
    },
};